import { render, staticRenderFns } from "./RegistPerExam.vue?vue&type=template&id=2b7b98ed&scoped=true&v-slot%3Acontent=true&"
import script from "./RegistPerExam.vue?vue&type=script&lang=ts&"
export * from "./RegistPerExam.vue?vue&type=script&lang=ts&"
import style0 from "./RegistPerExam.vue?vue&type=style&index=0&id=2b7b98ed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7b98ed",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VOverlay,VProgressCircular,VRow})
